var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaggageClaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/baggage-claim"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 6.25C1.25 5.55964 1.80964 5 2.5 5C3.49456 5 4.44839 5.39509 5.15165 6.09835C5.85491 6.80161 6.25 7.75544 6.25 8.75V20C6.25 20.3315 6.3817 20.6495 6.61612 20.8839C6.85054 21.1183 7.16848 21.25 7.5 21.25H27.5C28.1904 21.25 28.75 21.8096 28.75 22.5C28.75 23.1904 28.1904 23.75 27.5 23.75H7.5C6.50544 23.75 5.55161 23.3549 4.84835 22.6516C4.14509 21.9484 3.75 20.9946 3.75 20V8.75C3.75 8.41848 3.6183 8.10054 3.38388 7.86612C3.14946 7.6317 2.83152 7.5 2.5 7.5C1.80964 7.5 1.25 6.94036 1.25 6.25Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 23.75C21.8096 23.75 21.25 24.3096 21.25 25C21.25 25.6904 21.8096 26.25 22.5 26.25C23.1904 26.25 23.75 25.6904 23.75 25C23.75 24.3096 23.1904 23.75 22.5 23.75ZM18.75 25C18.75 22.9289 20.4289 21.25 22.5 21.25C24.5711 21.25 26.25 22.9289 26.25 25C26.25 27.0711 24.5711 28.75 22.5 28.75C20.4289 28.75 18.75 27.0711 18.75 25Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 23.75C10.5596 23.75 10 24.3096 10 25C10 25.6904 10.5596 26.25 11.25 26.25C11.9404 26.25 12.5 25.6904 12.5 25C12.5 24.3096 11.9404 23.75 11.25 23.75ZM7.5 25C7.5 22.9289 9.17893 21.25 11.25 21.25C13.3211 21.25 15 22.9289 15 25C15 27.0711 13.3211 28.75 11.25 28.75C9.17893 28.75 7.5 27.0711 7.5 25Z",
    fill: "#D1D5DB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaggageClaim);
export default __webpack_public_path__ + "static/media/baggage-claim.82ba8776dfed97ffde455cff3ab05c9d.svg";
export { ForwardRef as ReactComponent };